import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { router } from './router';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';
import { initializeAnalytics } from './lib/analytics-init';

export default function App() {
  useEffect(() => {
    initializeAnalytics();
  }, []);

  return (
    <HelmetProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </HelmetProvider>
  );
}